import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline PWA support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('App is now available offline!');
  },
  onUpdate: (registration) => {
    console.log('New version available – activating update...');
    // Tell the waiting service worker to take over immediately
    if (registration.waiting) {
      registration.waiting.postMessage('skipWaiting');
    }
  }
});

// Reload once when a new service worker takes control (new deploy activated)
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
